export function findClosestParentByClass(element, className) {

  let parentNode = element.parentNode;

  while (parentNode?.classList?.contains(className) === false) {
    parentNode = parentNode.parentNode;
  }

  return parentNode || null;

}

export function createDataURIForStartupIcon(startup) {

}

export function tryInsertFavicon(startup) {

  const faviconLinkId = 'startup-favicon';

  let faviconLink = document.getElementById(faviconLinkId);

  if (faviconLink !== null) {
    faviconLink.parentNode.removeChild(faviconLink);
  }

  let iconURL = startup.icon.url;

  faviconLink = document.createElement('link');

  faviconLink.setAttribute('id', faviconLinkId);
  faviconLink.setAttribute('rel', 'icon');
  faviconLink.setAttribute('href', iconURL);

  document.head.appendChild(faviconLink);

}

export function preventPropogation(event) {
  event.stopPropagation();
};

export function calculateNumberOfRowsCanFixedInAvailableScreen(container, rowHeight, tableHeaderHeight, extraRowCount, defaultRows = 20) {

  let rows = 20;

  if (container === null) {
    return defaultRows;
  }

  const containerHeight = container.offsetHeight;
  const availableHeight = containerHeight - tableHeaderHeight;

  rows = Math.floor(availableHeight / rowHeight) + extraRowCount;

  return rows;

}